import React, { useEffect } from 'react';
import Bluebird from 'bluebird';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import * as userRegistrationsActions from '../actions/userRegistrations';
import * as usersActions from '../actions/users';
import * as sitesActions from '../actions/sites';
import InProgressRegistrationsTable from '../components/InProgressRegistrationsTable';
import { Roles } from '../models/roles';
import { currentlyLoggedInOrImpersonatingUserHasAnyRoleInCurrentlySelectedSite } from '../services/auth';
import useActiveSite from '../hooks/useActiveSite';
import snackbarHelper from '../helpers/snackbarHelper';

const InProgressRegistrationsListView = () => {
  const dispatch = useDispatch();
  const activeSite = useActiveSite();
  const userRegistrations = useSelector(state => state.entities.userRegistrations);
  const userRegistrationsList = userRegistrations.allIds.map(
    userRegistrationId => userRegistrations.byId[userRegistrationId]
  );
  const users = useSelector(state => state.entities.sites.users);
  const usersList = users.bySiteId[activeSite.id] || [];
  const deleteUserRegistration = userRegistrationId => dispatch(userRegistrationsActions.deleteUserRegistration(userRegistrationId));

  const isAdmin = currentlyLoggedInOrImpersonatingUserHasAnyRoleInCurrentlySelectedSite([
    Roles.Admin,
    Roles.NationalSiteDirector,
  ]);

  // Filter by site and tos accepted for SD access
  const userRegistrationsFilteredList = userRegistrationsList
    .filter((user) => user.tos_accepted)
    .filter((user) => (activeSite.zip_codes || []).find((zipCode) => zipCode === user.zip_code));

  useEffect(() => {
    dispatch(userRegistrationsActions.fetchUserRegistrationsIfNeeded());
    dispatch(sitesActions.fetchSiteUsersIfNeeded(activeSite.id));
  }, []);

  const sendEmailInvitation = (registartion, invitedUser = null) => {
    // Re-send invitation if user was invited (user_id exists)
    if (invitedUser?.id) {
      return Bluebird.try(() => dispatch(usersActions.resendUserInvitationEmail(invitedUser.id, activeSite.id)))
        .then(() => snackbarHelper.success(`Invitation has been sent`))
        .catch((err) => snackbarHelper.error(err.message));
    }

    // else re-send email verification
    return Bluebird.try(() => dispatch(userRegistrationsActions.resendVerificationEmail(registartion.id)))
      .then(() => snackbarHelper.success(`Invitation has been sent`))
      .catch((err) => snackbarHelper.error(err.message));
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <InProgressRegistrationsTable
          tableId="#user-registrations/in-progress-registrations"
          isLoading={userRegistrations.inflight || users.inflight}
          userRegistrations={isAdmin ? userRegistrationsList : userRegistrationsFilteredList}
          usersList={usersList}
          deleteUserRegistration={deleteUserRegistration}
          sendInvitation={sendEmailInvitation}
        />
      </Grid>
    </Grid>
  );
};

export default InProgressRegistrationsListView;
